import React, { useState } from 'react';
import './GoogleReviews.css';
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';

const reviews = [
  { name: 'Anshul Dwivedi', review: "I sustained a knee injury during a gym session, which made walking and running difficult. The knee therapy sessions at Saarthi Physiotherapy were fantastic! Dr. Aishwarya guided me through exercises and applied techniques that helped restore my mobility and functionality. I'm now back to my daily routine, and I'm incredibly grateful to the team. Thank you so much! You are the best in the area.", rating: 5 },

  { name: 'Jay bhusari', review: "I had a wrist fracture and struggled with simple tasks like writing and using utensils. The hand therapy sessions at Saarthi Physiotherapy were incredible! Dr.Aishwarya  taught me exercises and used techniques that restored my grip and functions. I’m back to my daily routine now, and I can’t thank the team enough.Thank you thank you thank you so much. You are the Best in the area.", rating: 5 },

  { name: 'Monica Manwani', review: "I had been suffering from back pain for several years due to compressed nerves, and after trying many things with little relief, I finally decided to visit Saarthi physiotherapy centre. The clinic is very well facilitated and has a comfortable environment. Dr. Aishwarya is highly skilled and attentive to each patient's needs. With regular sessions, I have experienced significant improvement in my back pain and am thankful for the care and support I received here.", rating: 4.5 },

  { name: 'Swati Kulkarni', review: "I got very good experience at Saarthi Physiotherapy center which is very well equipped and under expert guidance of Dr Joshi I could get immediate relief and comfort from my ailment", rating: 5 },

  { name: 'Ganesh Mulage', review: "I had an excellent experience,They designed a personalized treatment plan that effectively targeted my needs, and their supportive approach made each session comfortable and motivating. Thanks to their expertise and care.", rating: 4.5 },

  { name: 'Priyanka Deshmukh', review: "I was there for my back pain and i got relief! Thanks to Dr. Joshi for her patience and dedication.Will surely recommend for ortho related physio", rating: 5 },

  { name: 'Kashish Malik', review: "Saarthi physiotherapy centre looks into your issues througly.Actually Dr. Aishwarya understands the issue and provide customised exercises to reduce the pain. I had severe frozen shoulder pain where they helped me with the range of motion and reduce my pain & discomfort. I would definitely recommend you to visit for your problems", rating: 4.5 },

  { name: 'Appurva Dabi', review: "My self Appurva Dabi, suffering from right knee pain due to fall from two wheeler on the road one month back.After medical treatment ,l approached Dr.Aishwarya Joshi(Saarthi  physiotherapy clinic/center), Dr.practically observed through X ray & explained the difficulty.And very nicely started treatment.Now after 15 days I got lot of improvement,now I can independently walk now because of good treatment &care. Keep up the good work doctor!", rating: 4.5 },
];

const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const halfStar = rating % 1 >= 0.5;
  const stars = [];

  for (let i = 0; i < fullStars; i++) stars.push(<FaStar key={`full-${i}`} />);
  if (halfStar) stars.push(<FaStarHalfAlt key="half" />);
  while (stars.length < 5) stars.push(<FaRegStar key={`empty-${stars.length}`} />);
  return stars;
};

const GoogleReviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleDotClick = (index) => setCurrentIndex(index);

  return (
    <section className="google-reviews">
      <h3>What Our Clients Say</h3>
        <div className="rating-summary">
            <span className="star">⭐</span>
            <span className="rating-value">4.9</span>
            <span className="rating-text">Based on 50+ Google Reviews</span>
        </div>

      <div className="review-carousel">
        <div
          className="review-slider"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {reviews.map((rev, index) => (
            <div className="review-card" key={index}>
              <p className="review-text">"{rev.review}"</p>
              <div className="review-rating">{renderStars(rev.rating)}</div>
              <p className="review-name">- {rev.name}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="carousel-dots">
        {reviews.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
          />
        ))}
      </div>

      <div className="see-more">
        <a
          href="https://www.google.com/maps/place/Saarthi+Physiotherapy+Center/@18.569168,73.781425,15z/data=!4m8!3m7!1s0x3bc2bf96cd0321bb:0xa999801c96e618fb!8m2!3d18.5691675!4d73.781425!9m1!1b1!16s%2Fg%2F11ldxb59wc?hl=en&entry=ttu&g_ep=EgoyMDI1MDQwNy4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
        >
          See More Reviews →
        </a>
      </div>
    </section>
  );
};

export default GoogleReviews;
